module.exports = __webpack_public_path__ + "img/11.3abe6a8c.jpg";